module.exports = "https://cdn01.riselinkedu.com/assets/images/logo.46b24cf.png";